import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-calloutslider").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Navigation],
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    speed: 500,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });
});
